<template>
  <div class="mx-4 mb-4">
    <div class="mb-3 mt-4" style="position: relative">
      <div style="display: flex; align-items: center">
        <span class="main-title"> WELLNESS REPORT </span>
      </div>
      <v-divider></v-divider>
      <!-- ------------------------------- Report Detail Modal --------------------------------------- -->
      <v-layout justify="center">
        <v-dialog v-model="dialog" width="600px" v-if="reportDetail != null">
          <v-card>
            <v-card-title>
              <span class="headline">Report Detail</span>
              <v-spacer></v-spacer>
              <v-btn icon @click="dialog = false"
                ><v-icon>mdi-close</v-icon></v-btn
              >
            </v-card-title>

            <v-card-text style="overflow: auto; max-height: 600px">
              <v-layout>
                <v-flex cols="12">
                  <v-img
                    lazy-src="https://picsum.photos/id/11/10/6"
                    max-height="200"
                    width="100%;"
                    :src="
                      reportDetail.order_detail.order_detail_product
                        .product_image
                    "
                  ></v-img>
                  <div
                    style="
                      border: 1px solid black;
                      border-radius: 20px;
                      margin-top: 40px;
                      padding: 20px;
                    "
                  >
                    <div>
                      <span>Store name:</span
                      ><span> {{ reportDetailStoreName }}</span>
                    </div>
                    <div>
                      <span>Order Code:</span
                      ><span> {{ reportDetail.order_code }}</span>
                    </div>
                    <div>
                      <span>Order Customer Name:</span
                      ><span> {{ reportDetail.order_customer_name }}</span>
                    </div>
                    <div>
                      <span>Order Payment Method:</span
                      ><span>
                        {{
                          reportDetail.order_pay_method == 1
                            ? "Credit card"
                            : reportDetail.order_pay_method == 2
                            ? "Promptpay"
                            : ""
                        }}</span
                      >
                    </div>
                    <div>
                      <span>Order Booked Start:</span
                      ><span> {{ reportDetail.order_time_booked_start }}</span>
                    </div>
                    <div>
                      <span>Order Booked End:</span
                      ><span> {{ reportDetail.order_time_booked_end }}</span>
                    </div>
                  </div>

                  <v-text-field
                    style="margin-top: 20px"
                    v-model="reportDetail.order_discount_code"
                    label="Order Discount Code"
                    disabled
                    dense
                    filled
                  ></v-text-field>
                  <v-text-field
                    v-model="
                      reportDetail.order_detail.order_detail_product_price
                    "
                    label="Product Price"
                    placeholder="Placeholder"
                    suffix="฿"
                    disabled
                    dense
                    filled
                  ></v-text-field>
                  <v-text-field
                    v-model="reportDetail.order_detail.order_detail_amount"
                    label="Product Amount"
                    disabled
                    dense
                    filled
                  ></v-text-field>
                  <v-text-field
                    v-model="
                      reportDetail.order_detail.order_detail_product
                        .product_duration
                    "
                    label="Product Duration"
                    disabled
                    dense
                    filled
                    suffix="นาที"
                  ></v-text-field>
                  <v-text-field
                    v-model="reportDetail.order_detail.order_detail_total_price"
                    label="Product Total Price"
                    disabled
                    dense
                    filled
                    suffix=" ฿"
                  ></v-text-field>
                </v-flex>
              </v-layout>
            </v-card-text>
          </v-card>
        </v-dialog>
      </v-layout>
      <!-- ------------------------------- Sales Store Detail Modal --------------------------------------- -->
      <v-layout justify="center">
        <v-dialog
          v-model="dialogSaleStore"
          width="600px"
          v-if="saleStoreDetail != null"
        >
          <v-card>
            <v-card-title>
              <span class="headline">Sale Store Report Detail</span>
            </v-card-title>
            <hr />
            <v-card-text>
              <v-card dark color="primary" class="mb-10">
                <v-card-title>
                  <v-btn fab depressed color="amber accent-1"
                    ><v-icon center light> inventory </v-icon></v-btn
                  >
                  <span class="title font-weight-600">Order Lists</span>
                </v-card-title>
              </v-card>
            </v-card-text>
            <v-card-text>
              <v-layout>
                <v-flex>
                  <div style="height: 500px; overflow: auto">
                    <v-expansion-panel>
                      <v-expansion-panel-content
                        v-for="(item, i) in saleStoreDetail.order_list"
                        :key="i"
                      >
                        <template v-slot:header>
                          <div color="primary">
                            Order Code | {{ item.order_code }}
                          </div>
                        </template>
                        <v-card>
                          <v-card-text>
                            <div class="mb-2" style="font-weight: bold">
                              <v-icon>person</v-icon> Customer Detail
                            </div>
                            <hr />
                            <div class="mt-1">
                              Name: {{ item.order_customer_name }}
                            </div>
                            <div>Customer Id: {{ item.order_customer_id }}</div>
                            <div class="mb-2 mt-3" style="font-weight: bold">
                              <v-icon>info</v-icon> Order Detail
                            </div>
                            <hr />
                            <div class="mt-1">
                              Order Name:
                              {{
                                item.order_detail.order_detail_product
                                  .product_name_en
                              }}
                            </div>
                            <div>
                              Order ID:{{ item.order_detail.order_detail_id }}
                            </div>
                            <div>
                              Payment:
                              {{
                                item.order_pay_method == 1
                                  ? " Cash"
                                  : " Banking"
                              }}
                            </div>
                            <div>
                              Product Price:
                              {{ item.order_detail.order_detail_product_price }}
                            </div>
                            <div>
                              Discount Code: {{ item.order_discount_code }}
                            </div>
                            <div>
                              Total Net Price:
                              {{ item.order_total_net_price + " ฿" }}
                            </div></v-card-text
                          >
                        </v-card>
                      </v-expansion-panel-content>
                    </v-expansion-panel>
                  </div>
                </v-flex>
              </v-layout>
            </v-card-text>
          </v-card>
        </v-dialog>
      </v-layout>
      <div style="display: flex; justify-content: flex-end; margin-top: 20px">
        <!------------------------------ Exported XLS ---------------------------------------->
        <download-excel
          :data="reportList.order"
          v-if="reportTypeSelected == 1"
          :fields="{
            'Order Code': 'order_code',
            'Store Name': 'order_detail.order_detail_store.store_name_th',
            'Order Amount': 'order_amount',
            'Total Product Price': 'order_total_product_price',
            'Total Discount Price': 'order_total_discount_price',
            'Order Total Net Price': 'order_total_net_price',
            'Customer Name': 'order_customer_name',
            'Booked Start': 'order_time_booked_start',
            'Booked End': 'order_time_booked_end',
            'Order Status': 'order_status',
          }"
          :name="`Wellness_OrderReport_${moment().format('YYYY-MM-DD')}.xls`"
          style="margin-right: 5px"
        >
          <v-btn color="primary" class="black--text"> Export .XLS </v-btn>
        </download-excel>
        <download-excel
          :data="reportList.collect_promotion_code"
          v-else-if="reportTypeSelected == 2"
          :fields="{
            'Promotion Code': `promotion_code`,
            'Promotion Name': `promotion_name_th`,
            'Discount Percent': 'promotion_discount_percent',
            'Discount Price': 'promotion_discount_price',
            'Promotion Amount': 'promotion_amount',
            'Promtion Used': 'promotion_used',
            'Paid Promotion': `promotion_total_paid_promotion`,
          }"
          :name="`Wellness_PromotionReport_${moment().format(
            'YYYY-MM-DD'
          )}.xls`"
          style="margin-right: 5px"
        >
          <v-btn color="primary" class="black--text"> Export .XLS </v-btn>
        </download-excel>
        <download-excel
          :data="reportList.data"
          v-else
          :fields="{
            'Store Name': `store_name_th`,
            'Package Name': `package_name`,
            'Order Amount': `order_amount`,
            'Total Price': `total_price`,
            'Commission %': `package_commission`,
            'Commission Paid': `commission_paid`,
            'Total Paid': `total_paid`,
            'Bank Name': `bank_name`,
            'Store Account Name': `store_account_name`,
            'Store Account Number': `store_account_number`,
          }"
          :name="`Wellness_SalesStoreReport_${moment().format(
            'YYYY-MM-DD'
          )}.xls`"
          style="margin-right: 5px"
        >
          <v-btn color="primary" class="black--text"> Export .XLS </v-btn>
        </download-excel>
        <!------------------------------ Exported CSV ---------------------------------------->
        <download-excel
          type="csv"
          :data="reportList.order"
          v-if="reportTypeSelected == 1"
          :fields="{
            'Order Code': 'order_code',
            'Store Name': 'order_detail.order_detail_store.store_name_th',
            'Order Amount': 'order_amount',
            'Total Product Price': 'order_total_product_price',
            'Total Discount Price': 'order_total_discount_price',
            'Order Total Net Price': 'order_total_net_price',
            'Customer Name': 'order_customer_name',
            'Booked Start': 'order_time_booked_start',
            'Booked End': 'order_time_booked_end',
            'Order Status': 'order_status',
          }"
          :name="`Wellness_OrderReport_${moment().format('YYYY-MM-DD')}.xls`"
          style="margin-right: 5px"
        >
          <v-btn color="primary" class="black--text"> Export .CSV </v-btn>
        </download-excel>
        <download-excel
          type="csv"
          :data="reportList.collect_promotion_code"
          v-else-if="reportTypeSelected == 2"
          :fields="{
            'Promotion Code': `promotion_code`,
            'Promotion Name': `promotion_name_th`,
            'Discount Percent': 'promotion_discount_percent',
            'Discount Price': 'promotion_discount_price',
            'Promotion Amount': 'promotion_amount',
            'Promtion Used': 'promotion_used',
            'Paid Promotion': `promotion_total_paid_promotion`,
          }"
          :name="`Wellness_PromotionReport_${moment().format(
            'YYYY-MM-DD'
          )}.xls`"
          style="margin-right: 5px"
        >
          <v-btn color="primary" class="black--text"> Export .CSV </v-btn>
        </download-excel>
        <download-excel
          type="csv"
          :data="reportList.data"
          v-else
          :fields="{
            'Store Name': `store_name_th`,
            'Package Name': `package_name`,
            'Order Amount': `order_amount`,
            'Total Price': `total_price`,
            'Commission %': `package_commission`,
            'Commission Paid': `commission_paid`,
            'Total Paid': `total_paid`,
            'Bank Name': `bank_name`,
            'Store Account Name': `store_account_name`,
            'Store Account Number': `store_account_number`,
          }"
          :name="`Wellness_SalesStoreReport_${moment().format(
            'YYYY-MM-DD'
          )}.xls`"
          style="margin-right: 5px"
        >
          <v-btn color="primary" class="black--text"> Export .CSV </v-btn>
        </download-excel>
      </div>
    </div>
    <div class="search-panel">
      <v-layout no-gutters justify-center>
        <v-flex class="d-flex align-center">
          <div class="ml-4 mb-1" v-if="reportTypeSelected != 2">
            <v-menu v-model="menu1" :close-on-content-click="false">
              <template v-slot:activator="{ on }">
                <v-text-field
                  :value="params.datetime_start"
                  readonly
                  prepend-inner-icon="mdi-calendar-month-outline"
                  label="Time Start"
                  v-on="on"
                ></v-text-field>
              </template>
              <v-date-picker
                v-model="params.datetime_start"
                @change="menu1 = false"
              ></v-date-picker>
            </v-menu>
          </div>

          <div class="mx-4 mb-1" v-if="reportTypeSelected != 2">
            <v-menu v-model="menu2" :close-on-content-click="false">
              <template v-slot:activator="{ on }">
                <v-text-field
                  :value="params.datetime_end"
                  label="Time End"
                  prepend-inner-icon="mdi-calendar-month-outline"
                  readonly
                  v-on="on"
                ></v-text-field>
              </template>
              <v-date-picker
                v-model="params.datetime_end"
                @change="menu2 = false"
              ></v-date-picker>
            </v-menu>
          </div>
          <v-btn
            color="primary"
            @click="onFilterReport()"
            v-if="reportTypeSelected != 2"
            class="mr-4 mb-3 black--text"
          >
            <v-icon class="mr-1">search</v-icon> Search
          </v-btn></v-flex
        >
      </v-layout>
      <v-layout no-gutters>
        <v-flex class="d-flex align-center">
          <v-select
            :items="reportType"
            v-model="reportTypeSelected"
            class="ml-4 mr-4"
            placeholder="Report type"
            prepend-inner-icon="mdi-file-chart"
            color="primary"
            item-text="name"
            item-value="value"
            @change="onSelectReportType()"
          ></v-select>
          <v-btn
            class="mr-4 black--text"
            color="primary"
            @click="onFilterReport()"
            v-if="reportTypeSelected == 2"
          >
            <v-icon class="mr-1">search</v-icon> Search
          </v-btn>
          <v-select
            v-if="showSelected"
            :items="storeList"
            v-model="params.store_id"
            class="ml-4 mr-4"
            placeholder="Select Store"
            prepend-inner-icon="mdi-store-minus"
            color="primary"
            item-text="store_name_th"
            item-value="store_id"
          ></v-select>
          <v-select
            v-if="showSelected"
            placeholder="Service"
            v-model="params.order_type"
            :items="orderTypeList"
            class="ml-4 mr-4"
            prepend-inner-icon="mdi-filter"
            color="primary"
            item-text="name"
            item-value="value"
          ></v-select>
          <v-select
            :items="orderStatusList"
            v-model="params.order_status"
            v-if="showSelected && reportTypeSelected != 3"
            item-text="name"
            item-value="value"
            :menu-props="{ transition: 'slide-x-transition' }"
            class="ml-4 mr-4"
            placeholder="Order Status"
            prepend-inner-icon="mdi-filter-variant"
            color="primary"
          ></v-select>
        </v-flex>
      </v-layout>
      <v-layout
        ><v-flex class="d-flex align-center pr-4 pl-4">
          <v-text-field
            solo
            v-if="reportTypeSelected == 2"
            placeholder="ค้นหา"
            label="Prepend inner"
            v-model="keyWord"
            @input="onSearchPromotion()"
            prepend-inner-icon="mdi-magnify"
          ></v-text-field> </v-flex
      ></v-layout>
    </div>
    <!-------------------------------order table--------------------------------------- -->
    <v-data-table
      :menu-props="{ transition: 'slide-x-transition' }"
      :loading="loadingActive"
      loading-text="Loading... Please wait"
      color="primary"
      v-if="reportTypeSelected == 1"
      :headers="reportTypeSelected == 1 ? headers : ''"
      :items="reportList.order"
      :items-per-page="10"
      :expand="true"
      class="elevation-1"
    >
      <template v-slot:items="props">
        <tr>
          <td>
            {{ reportList.order.indexOf(props.item) + 1 }}
          </td>
          <td class="text-xs-center">
            {{ props.item.order_code }}
          </td>
          <td class="text-xs-center" expand="true">
            {{ props.item.order_detail.order_detail_store.store_name_th }}
          </td>
          <td class="text-xs-center">
            {{ props.item.order_amount }}
          </td>
          <td class="text-xs-center">
            {{ props.item.order_total_product_price }}
          </td>
          <td class="text-xs-center">
            {{ props.item.order_total_discount_price }}
          </td>
          <td class="text-xs-center">
            {{ props.item.order_total_net_price }}
          </td>
          <td class="text-xs-center">
            {{ props.item.order_customer_name }}
          </td>
          <td class="text-xs-center">
            {{ props.item.order_time_booked_start }}
          </td>
          <td class="text-xs-center">
            {{ props.item.order_time_booked_end }}
          </td>
          <td class="text-xs-center">
            <div
              @click="onViewReport(props.item)"
              style="cursor: pointer"
              :class="
                props.item.order_status == 5
                  ? 'status-complete'
                  : props.item.order_status == 6
                  ? 'status-cancel'
                  : 'default-status'
              "
            >
              {{
                props.item.order_status == 1
                  ? "Request"
                  : props.item.order_status == 2
                  ? "Pre-Order"
                  : props.item.order_status == 3
                  ? "Ready"
                  : props.item.order_status == 4
                  ? "Process"
                  : props.item.order_status == 5
                  ? "Complete"
                  : props.item.order_status == 6
                  ? "Cancel"
                  : props.item.order_status == 7
                  ? "Pending"
                  : ""
              }}
            </div>
          </td>
        </tr>
      </template>

      <template v-if="this.reportList.length > 0" v-slot:footer>
        <TotalNetPrice
          v-if="reportList.total_net_price !== undefined"
          :netPrice="reportList.total_net_price"
        ></TotalNetPrice>
        <Summary v-else :reportList="reportList"></Summary>
      </template>
    </v-data-table>

    <!--------------------------promotion table------------------------------->
    <v-data-table
      :menu-props="{ transition: 'slide-x-transition' }"
      :loading="loadingActive"
      loading-text="Loading... Please wait"
      v-if="reportTypeSelected == 2"
      :headers="reportTypeSelected == 2 ? headersPromoCode : ''"
      :items="reportList.collect_promotion_code"
      :items-per-page="10"
      class="elevation-1"
    >
      <template v-slot:items="props">
        <tr>
          <td>
            {{ reportList.collect_promotion_code.indexOf(props.item) + 1 }}
          </td>
          <td class="text-xs-center">
            {{ props.item.promotion_code }}
          </td>
          <td class="text-xs-center" expand="true">
            {{
              props.item.promotion_name_th ||
              props.item.promotion_name_en ||
              "No promotion name"
            }}
          </td>
          <td class="text-xs-center">
            {{
              props.item.promotion_discount_price == 0
                ? props.item.promotion_discount_percent + " %"
                : props.item.promotion_discount_price + " ฿"
            }}
          </td>
          <td class="text-xs-center">
            {{ props.item.promotion_amount }}
          </td>
          <td class="text-xs-center">
            {{ props.item.promotion_used + "/" + props.item.promotion_amount }}
          </td>
          <td class="text-xs-center">
            {{ props.item.promotion_total_paid_promotion }}
          </td>
        </tr>
      </template>
    </v-data-table>

    <!-- -------------------SaleStore table ---------------------->
    <v-data-table
      :menu-props="{ transition: 'slide-x-transition' }"
      :loading="loadingActive"
      loading-text="Loading... Please wait"
      v-if="reportTypeSelected == 3"
      :headers="reportTypeSelected == 3 ? headersSaleStore : ''"
      :items="reportList.data"
      :items-per-page="10"
      class="elevation-1"
    >
      <template v-slot:items="props">
        <tr>
          <td>
            {{ reportList.data.indexOf(props.item) + 1 }}
          </td>
          <td class="text-xs-center">
            {{ props.item.store_name_th }}
          </td>
          <td class="text-xs-center">
            {{ props.item.package_name }}
          </td>
          <td class="text-xs-center">
            {{ props.item.order_list[0].order_amount }}
          </td>
          <td class="text-xs-center">
            {{ props.item.total_price }}
          </td>
          <td class="text-xs-center">
            {{ props.item.package_commission }}
          </td>
          <td class="text-xs-center">
            {{ props.item.commission_paid }}
          </td>
          <td class="text-xs-center">
            {{ props.item.total_paid }}
          </td>
          <td class="text-xs-center">
            {{ props.item.bank_name }}
          </td>
          <td class="text-xs-center">
            {{ props.item.store_account_name }}
          </td>
          <td class="text-xs-center">
            {{ props.item.store_account_number }}
          </td>
          <td>
            <v-btn icon @click="onViewSaleStore(props.item)"
              ><v-icon>visibility</v-icon></v-btn
            >
          </td>
        </tr>
      </template>
      <template v-if="this.reportList.length > 0" v-slot:footer>
        <CommissionPaid
          :totalCommissionPaid="reportList.total_commission_paid"
        ></CommissionPaid>
        <TotalNetIncome
          :totalNetPrice="reportList.total_all_net_price"
        ></TotalNetIncome>
      </template>
    </v-data-table>
  </div>
</template>

<script>
import { mapActions, mapState } from "vuex";
import Summary from "../../../../components/back-office/ArtisgoReport/Summary.vue";
import TotalNetPrice from "../../../../components/back-office/ArtisgoReport/TotalNetPrice.vue";
import CommissionPaid from "../../../../components/back-office/ArtisgoReport/CommissionPaid.vue";
import TotalNetIncome from "../../../../components/back-office/ArtisgoReport/TotalSalesStoreNet.vue";
import moment from "moment";
export default {
  components: {
    Summary,
    TotalNetPrice,
    CommissionPaid,
    TotalNetIncome,
  },
  data() {
    const headers = [
      {
        text: "No",
        value: "no",
        align: "center",
        sortable: false,
      },
      {
        text: "Order Code",
        align: "center",
        sortable: false,
        value: "order_code",
      },
      {
        text: "Store Name",
        align: "center",
        sortable: false,
        value: "order_store_id",
      },
      {
        text: "Order Amount",
        align: "center",
        sortable: false,
        value: "order_amount",
      },
      {
        text: "Total Product Price",
        value: "order_total_product_price",
        align: "center",
        sortable: false,
      },
      {
        text: "Discount Price",
        value: "order_total_discount_price",
        align: "center",
        sortable: false,
      },
      {
        text: "Order Total Net Price",
        value: "order_total_net_price",
        align: "center",
        sortable: false,
      },
      {
        text: "Customer",
        value: "order_customer_name",
        align: "center",
        sortable: false,
      },
      {
        text: "Booked start",
        value: "order_time_booked_start",
        align: "center",
        sortable: false,
      },
      {
        text: "Booked end",
        value: "order_time_booked_end",
        align: "center",
        sortable: false,
      },
      {
        text: "Order status",
        value: "order_status",
        align: "center",
        sortable: false,
      },
    ];

    const headersSaleStore = [
      {
        text: "No",
        value: "no",
        align: "center",
        sortable: false,
      },
      {
        text: "Store Name",
        value: "store_name_th",
        align: "center",
        sortable: false,
      },
      {
        text: "Package",
        value: "package_name",
        align: "center",
        sortable: false,
      },
      {
        text: "Order Amount",
        value: "order_amount",
        align: "center",
        sortable: false,
      },
      {
        text: "Total Price",
        value: "total_price",
        align: "center",
        sortable: false,
      },
      {
        text: "Commission %",
        value: "package_commission",
        align: "center",
        sortable: false,
      },
      {
        text: "Commission Paid",
        value: "commission_paid",
        align: "center",
        sortable: false,
      },
      {
        text: "Total Paid",
        value: "total_paid",
        align: "center",
        sortable: false,
      },
      {
        text: "Bank Name",
        value: "bank_name",
        align: "center",
        sortable: false,
      },
      {
        text: "Store Account Name",
        value: "store_account_name",
        align: "center",
        sortable: false,
      },
      {
        text: "Store Account Number",
        value: "store_account_number",
        align: "center",
        sortable: false,
      },

      {
        text: "Action",
        value: "action",
        align: "center",
        sortable: false,
      },
    ];

    const headersPromoCode = [
      {
        text: "No",
        value: "no",
        align: "center",
        sortable: false,
      },
      {
        text: "Promotion Code",
        value: "promotion_code",
        align: "center",
        sortable: false,
      },
      {
        text: "Promotion Name",
        value: "promotion_name_th",
        align: "center",
        sortable: false,
      },
      {
        text: "Discount",
        value: "promotion_type",
        align: "center",
        sortable: false,
      },
      {
        text: "Amount",
        value: "promotion_amount",
        align: "center",
        sortable: false,
      },
      {
        text: "Use/Amount",
        value: "promotion_used",
        align: "center",
        sortable: false,
      },
      {
        text: "Paid Promotion",
        value: "promotion_total_paid_promotion",
        align: "center",
        sortable: false,
      },
    ];

    return {
      orderStatusItem: [
        { order_status: 1, order_status_name: "request", count: 19 },
        { order_status: 2, order_status_name: "pre-order", count: 0 },
        { order_status: 3, order_status_name: "ready", count: 0 },
        { order_status: 4, order_status_name: "process", count: 0 },
        { order_status: 5, order_status_name: "completed", count: 3 },
        { order_status: 6, order_status_name: "canceled", count: 0 },
        { order_status: 7, order_status_name: "pending", count: 4 },
        { order_status: 8, order_status_name: "postpone", count: 2 },
      ],
      menu1: false,
      menu2: false,
      timerID: null,
      keyWord: null,
      isExporting: false,
      dialogSaleStore: false,
      reportDetail: null,
      reportDetailStoreName: "",
      saleStoreDetail: null,
      dialog: false,
      params: {
        datetime_start: new Date().toISOString().substr(0, 10),
        datetime_end: new Date().toISOString().substr(0, 10),
        report_type: 1,
        order_type: 1,
        order_status: 5,
        store_id: 0,
        provider_type: 0,
        key_word: "",
      },
      loadingActive: false,
      showSelected: true,
      orderStatus: 1,
      reportTypeSelected: 1,
      orderTypeList: [
        {
          name: "All",
          value: 3,
        },
        {
          name: "Store",
          value: 1,
        },
        {
          name: "Home",
          value: 2,
        },
      ],
      orderStatusList: [
        {
          name: "Request",
          value: 1,
        },
        {
          name: "Pre-Order",
          value: 2,
        },
        {
          name: "Ready",
          value: 3,
        },
        {
          name: "Process",
          value: 4,
        },
        {
          name: "Complete",
          value: 5,
        },
        {
          name: "Cancel",
          value: 6,
        },
        {
          name: "Pending",
          value: 7,
        },
      ],
      headersSaleStore,
      headers,
      headersPromoCode,
    };
  },
  watch: {
    $route() {
      this.onSelectReportType();
    },
  },

  computed: {
    ...mapState({
      storeList: (state) => state.fetchWellnessReport.storeList,
      reportList: (state) => state.fetchWellnessReport.reportList,
    }),

    reportType() {
      let report = [];

      report = [
        {
          name: "Order Report",
          value: 1,
        },
        {
          name: "Sale Store Report",
          value: 3,
        },
      ];

      return report;
    },
  },
  methods: {
    ...mapActions({
      getAllStore: "fetchWellnessReport/getAllStores",
      getReport: "fetchWellnessReport/getReport",
      resetReportList: "fetchWellnessReport/resetReportList",
    }),
    moment,

    onSearchPromotion() {
      clearTimeout(this.timerID);
      this.timerID = setTimeout(() => {
        this.params.report_type = this.reportTypeSelected;
        this.params.key_word = this.keyWord;
        this.loadingActive = true;
        this.$emit("getReport", {
          data: this.params,
          done: (rs) => {
            if (rs == true) {
              console.log(rs);
            }
            this.loadingActive = false;
          },
        });
      }, 500);
    },
    onViewSaleStore(item) {
      this.dialogSaleStore = !this.dialogSaleStore;
      this.saleStoreDetail = JSON.parse(JSON.stringify(item));
    },
    async onViewReport(item) {
      this.dialog = !this.dialog;
      this.reportDetail = JSON.parse(JSON.stringify(item));
      let payloadStore = {
        page_size: item.order_store_id,
        current_page: 1,
        search_store_type_id: 0,
        last: 0,
        search: "",
        store_recommend: 0,
      };
      this.reportDetailStoreName = "";
      try {
        await this.getAllStore(payloadStore);
        let index = this.storeList.findIndex(
          (val) => val.store_id == item.order_store_id
        );
        this.reportDetailStoreName = this.storeList[index].store_name_th;
      } catch (err) {
        console.log(err);
      }
    },
    async onFilterReport() {
      this.params.report_type = this.reportTypeSelected;
      this.loadingActive = true;

      let result = await this.getReportByUser(this.params);
      if (result != null || result != undefined) {
        this.loadingActive = false;
      } else {
        this.loadingActive = false;
      }
    },
    async getReportByUser(data) {
      let rs = await this.getReport(data);
      return rs;
    },
    onSelectReportType() {
      if (this.reportTypeSelected == 1 || this.reportTypeSelected == 3) {
        this.showSelected = true;
      } else {
        this.showSelected = false;
      }
      this.resetReportList();
    },
  },
  mounted() {
    this.$store.dispatch("fetchWellnessReport/getAllStores");
  },
};
</script>

<style scoped>
.main-title {
  font-size: 28px;
  font-weight: bold;
  letter-spacing: 3px;
}
.submain-title {
  font-size: 20px;
  color: #707070;
}
.search-panel {
  background-color: white;
  width: 100%;
  padding-top: 10px;
  padding-bottom: 10px;
  /* height: 120px; */
  margin-bottom: 10px;
  border-radius: 5px;
  box-shadow: 0.5;
  -webkit-box-shadow: 0px 2px 8px -2px rgba(204, 202, 204, 1);
  -moz-box-shadow: 0px 2px 8px -2px rgba(204, 202, 204, 1);
  box-shadow: 0px 2px 8px -2px rgba(204, 202, 204, 1);
}
.status-cancel {
  background-color: red;
  padding: 5px;
  font-size: 10px;
  letter-spacing: 1px;
  color: white;
  border-radius: 2px;
}
.default-status {
  background-color: #fe6b81;
  padding: 5px;
  font-size: 10px;
  letter-spacing: 1px;
  color: white;
  border-radius: 2px;
}
.status-complete {
  background-color: green;
  padding: 5px;
  font-size: 10px;
  letter-spacing: 1px;
  color: white;
  border-radius: 2px;
}
</style>
